export default __webpack_public_path__ + "static/media/logo-estrela.4052d6bc.png";